import React, { createContext, useContext, useState, useCallback } from 'react';
import HeaderSubscribeModal from '../projects/components/HeaderSubscribeModal';
import { PROJECT_BLOCKER, SUBSCRIPTION_PAST_DUE, UNCANCEL_SUBSCRIPTION } from '../constants/AccountPageConstants';
import { useCurrentProject } from 'hooks/projects/useCurrentProject';

// Create the context
const BillingModalContext = createContext();

/**
 * Provider component that manages the billing modal state
 */
export function BillingModalProvider({ children }) {
  const [billingModalPage, setBillingModalPage] = useState(null);
  const { projectId } = useCurrentProject();

  const hideBillingModal = useCallback(() => {
    setBillingModalPage(null);
  }, []);

  const showProjectBlocker = useCallback(() => {
    setBillingModalPage(PROJECT_BLOCKER);
  }, []);

  const showSubscriptionPastDue = useCallback(() => {
    setBillingModalPage(SUBSCRIPTION_PAST_DUE);
  }, []);

  const showRenewalModal = useCallback(() => {
    setBillingModalPage(UNCANCEL_SUBSCRIPTION);
  }, []);

  const value = {
    billingModalPage,
    showProjectBlocker,
    showSubscriptionPastDue,
    showRenewalModal,
    hideBillingModal,
  };

  const onSubscribe = () => {
    setBillingModalPage(UNCANCEL_SUBSCRIPTION);
  }

  return (
    <BillingModalContext.Provider value={value}>
      <>
        {children}
        <HeaderSubscribeModal
          show={!!billingModalPage}
          page={billingModalPage}
          hideBackButton={true}
          onHide={hideBillingModal}
          onSubscribe={onSubscribe}
          projectId={projectId}
        />
      </>
    </BillingModalContext.Provider>
  );
}

/**
 * Hook to use the billing modal context
 */
export function useBillingModal() {
  const context = useContext(BillingModalContext);
  if (!context) {
    throw new Error('useBillingModal must be used within a BillingModalProvider');
  }
  return context;
}

export default BillingModalContext;